// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import { Link, Typography } from "@aviary";
import { AuthFooter } from "@shared/components/AuthFooter/AuthFooter";
import { AuthHeader } from "@shared/components/AuthHeader/AuthHeader";
import { AuthHeaderWrapper } from "@shared/components/AuthHeaderWrapper/AuthHeaderWrapper";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { Page } from "@unauthenticated/signupSignin/components/Page/Page";
import { PageContent } from "@unauthenticated/signupSignin/components/PageContent/PageContent";
import { SignUpHeader } from "@unauthenticated/signupSignin/components/SignUpHeader/SignUpHeader";
import { StoreLogo } from "@unauthenticated/signupSignin/components/StoreLogo/StoreLogo";
import { l } from "@unauthenticated/signupSignin/locales/i18n";
import { OfficeResendInvitationForm } from "@unauthenticated/signupSignin/scenes/OfficeResendInvitationPage/OfficeResendInvitationForm/OfficeResendInvitationForm";

import * as styles from "./OfficeResendInvitationPage.styles";

type StoreAttributes = {
  storeId: string;
  storeLogo?: string;
  storeName: string;
};

interface Props {
  storeAttributes: StoreAttributes;
}

const OfficeResendInvitationPage = ({ storeAttributes }: Props) => {
  const { storeId, storeName, storeLogo } = storeAttributes;
  const { tablet } = useBreakpoints();
  const { t } = useTranslation();

  const renderForm = () => (
    <>
      <SignUpHeader>
        <StoreLogo storeLogo={storeLogo} storeName={storeName} />
        <Typography type={tablet.greaterThan ? "h2" : "h3"}>{storeName}</Typography>
        <Typography>{t(l.officeSignUp.ResendInvitation)}</Typography>
      </SignUpHeader>
      <OfficeResendInvitationForm storeId={storeId} />

      <Typography isMarginless type={tablet.greaterThan ? "body" : "footnote"}>
        {t(l.common.HaveAcount)}
        &nbsp;
        <Link href={authRoutes.login}>{t(l.common.SignIn)}</Link>
      </Typography>
    </>
  );

  return (
    <Page>
      <PageContent>
        <AuthHeaderWrapper>
          <AuthHeader route={authRoutes.login} />
        </AuthHeaderWrapper>
        <div css={styles.contentLayout}>{renderForm()}</div>
      </PageContent>
      <AuthFooter />
    </Page>
  );
};

export { OfficeResendInvitationPage };
